import { MenuButton } from 'components'
import { useTranslation } from 'react-i18next'

export const MoreActionsButton = ({
  toggleCheckboxes,
  showingArchived,
  openFile,
}) => {
  const { t } = useTranslation()
  return (
    <MenuButton
      left
      margin="0 16px 0 0"
      text={t('dashboard.moreActions')}
      items={[
        // {
        //   text: 'New memorial label',
        //   icon: 'plus',
        //   onClick: () => console.log('new memorial label'),
        // },
        {
          text: t('dashboard.importCase'),
          icon: 'importCase',
          onClick: () => openFile(),
        },
        {
          text: showingArchived
            ? t('dashboard.unarchiveMultiple')
            : t('dashboard.archiveMultiple'),
          icon: 'archive',
          onClick: () => toggleCheckboxes(),
        },
      ]}
    />
  )
}

export default MoreActionsButton
